import { useCallback, useState } from 'react';
import teamApi from '~/services/team';

const useAddNewMember = () => {
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  const addNewMember = useCallback(
    ({ firstName, lastName, email, phone, position, gender, image }) => {
      setLoading(true);
      return teamApi
        .addNewTeamMember({
          firstName,
          lastName,
          email,
          phone,
          position,
          gender,
          image,
        })
        .catch((error) => setError(error.message))
        .then(() => setLoading(false));
    },
    [],
  );

  return { loading, error, addNewMember };
};

export default useAddNewMember;
